import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./estilos/global.css";

const raiz = document.getElementById("raiz");
if (raiz === null) {
  // Não é defesa contra o improvável: é a diferença entre uma tela em branco
  // sem explicação e uma mensagem que diz onde procurar.
  throw new Error("O elemento #raiz não existe no index.html.");
}

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
